const DataReducer = (state, action) => {
  const capitalize = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  switch (action.type) {
    // Initial Reducers
    case "UPDATE_FROM_API":
      const data = action.payload.response;
      console.log(data);
      return {
        ...state,
        partExchange: {
          ...state.partExchange,
          make: data.make || "None specified",
          model: data.model || "None specified",
          registration: data.vrm || "None specified",
          mileage: data.mileage || "None specified",
          transmission: data.transmission || "None specified",
          fuel: data.fuel_type || "None specified",
          colour: data.colour || "None specified",
          contractStartDate: data.contract_start_date || "None specified",
          contractEndDate: data.contract_end_date || "None specified",
          monthlyPayment: data.monthly_payment || "None specified",
        },
        details: {
          ...state.details,
          title: data.title || "",
          firstName: capitalize(data.first_name.toLowerCase()) || "",
          lastName: capitalize(data.last_name.toLowerCase()) || "",
          emailAddress: data.email || "",
          mobile: data.mobile || "",
          phone: data.telephone1 || "",
          finance: data.finance || "",
          branchTradingName: data.participating_branch.trading_name || "",
          branchAddress1: data.participating_branch.address_1 || "",
          branchAddress2: data.participating_branch.address_2 || "",
          branchAddress3: data.participating_branch.address_3 || "",
          branchPostcode: data.participating_branch.postcode || "",
          branchTelephone: data.participating_branch.telephone || "",
          branchContactEmail: data.participating_branch.contact_email || "",
          branchToEmail: data.participating_branch.to_email || "",
          branchFromEmail: data.participating_branch.from_email || "",
        },
      };

    // End of Initial Reducers

    // Selection Reducers
    case "UPDATE_ALL_SELECTIONS":
      return { ...state, selection: action.data };
    case "UPDATE_SELECTION_PREFERENCE":
      const updatedPreferences = state.selection.preferences.map((item) => {
        if (item.title === action.title) {
          return { ...item, selected: !item.selected };
        } else {
          return item;
        }
      });
      return { ...state, selection: { ...state.selection, preferences: [...updatedPreferences] } };
    case "UPDATE_SELECTION_MODEL":
      const updatedModels = state.selection.models.map((item) => {
        if (item.title === action.title) {
          return { ...item, selected: !item.selected };
        } else {
          return item;
        }
      });
      return { ...state, selection: { ...state.selection, models: [...updatedModels] } };
    // End of Selection Reducers

    // Finance Reducers
    case "UPDATE_ALL_FINANCES":
      return { ...state, finance: action.data };
    case "UPDATE_FINANCE_BUDGET":
      const updatedBudgets = state.finance.budgets.map((item) => {
        if (item.title === action.title) {
          return { ...item, selected: true };
        } else {
          return { ...item, selected: false };
        }
      });
      return { ...state, finance: { ...state.finance, budgets: [...updatedBudgets] } };
    case "UPDATE_FINANCE_MILEAGE":
      const updatedMileages = state.finance.mileages.map((item) => {
        if (item.title === action.title) {
          return { ...item, selected: true };
        } else {
          return { ...item, selected: false };
        }
      });
      return { ...state, finance: { ...state.finance, mileages: [...updatedMileages] } };

    case "UPDATE_FINANCE_DEPOSIT":
      return { ...state, finance: { ...state.finance, deposit: action.data } };
    // End of Finance Reducers

    // PartExchange Reducers
    case "UPDATE_ALL_PARTEXCHANGE":
      return { ...state, partExchange: action.data };

    case "UPDATE_PARTEXCHANGE_CONDITION":
      const updatedCondition = state.partExchange.conditions.map((item) => {
        if (item.title === action.title) {
          return { ...item, selected: true };
        } else {
          return { ...item, selected: false };
        }
      });
      return { ...state, partExchange: { ...state.partExchange, conditions: [...updatedCondition] } };

    case "UPDATE_PARTEXCHANGE_MILEAGE":
      return { ...state, partExchange: { ...state.partExchange, currentMileage: action.data } };

    case "UPDATE_PARTEXCHANGE_COMMENTS":
      return { ...state, partExchange: { ...state.partExchange, comments: action.data } };
    // End of PartExchange Reducers

    // Details Reducers
    case "UPDATE_ALL_DETAILS":
      return { ...state, details: action.data };
    // End of Details Reducers
    case "UPDATE_DETAIL":
      const updatedDetails = { ...state.details, [action.data.name]: action.data.value };
      return { ...state, details: updatedDetails };
    // End of Details Reducers

    // Summary Reducers
    case "UPDATE_ALL_SUMMARY":
      return { ...state, summary: action.data };

    case "UPDATE_SUMMARY_CONTACTMETHOD":
      const updatedContactMethod = state.summary.contactMethods.map((item) => {
        if (item.title === action.title) {
          return { ...item, selected: !item.selected };
        } else {
          return item;
        }
      });
      return { ...state, summary: { ...state.summary, contactMethods: [...updatedContactMethod] } };

    case "UPDATE_SUMMARY_CONTACTTIME":
      const updatedContactTime = state.summary.contactTimes.map((item) => {
        if (item.title === action.title) {
          return { ...item, selected: !item.selected };
        } else {
          return item;
        }
      });
      return { ...state, summary: { ...state.summary, contactTimes: [...updatedContactTime] } };

    case "UPDATE_SUMMARY_CONTACTDAY":
      const updatedContactDay = state.summary.contactDays.map((item) => {
        if (item.title === action.title) {
          return { ...item, selected: !item.selected };
        } else {
          return item;
        }
      });
      return { ...state, summary: { ...state.summary, contactDays: [...updatedContactDay] } };
    // End of Summary Reducers

    // Appointment Reducers
    case "UPDATE_ALL_APPOINTMENTS":
      return { ...state, appointment: action.data };

    // case "UPDATE_APPOINTMENT_SELECTED_MODE":
    //   return { ...state, appointment: { ...state.appointment, SelectedMode: action.title } };

    case "UPDATE_APPOINTMENT_MODE":
      const updatedModes = state.appointment.modes.map((item) => {
        if (item.title === action.title) {
          return { ...item, selected: true };
        } else {
          return { ...item, selected: false };
        }
      });
      return { ...state, appointment: { ...state.appointment, modes: [...updatedModes] } };

    case "UPDATE_APPOINTMENT_LOCATION":
      const updatedLocation = state.appointment.modes.map((mode) => {
        return {
          ...mode,
          locations: mode.locations.map((location) => {
            if (location.title === action.title) {
              return { ...location, selected: true };
            } else {
              return { ...location, selected: false };
            }
          }),
        };
      });
      return { ...state, appointment: { ...state.appointment, modes: [...updatedLocation] } };

    // End of Appointment Reducers

    case "LOGOUT":
      return {
        ...state,
        welcome: {},
        selection: {
          preferences: [
            { title: "New", value: "New", selected: false },
            { title: "Pre-Reg", value: "Pre-Reg", selected: false },
            { title: "Ex-Demo", value: "Ex-Demo", selected: false },
            { title: "Used", value: "Used", selected: false },
          ],
          models: [
            {
              title: "up! 3 door",
              image: "up-3door.png",
              selected: false,
            },
            { title: "up! 5 door", image: "up-5door.png", selected: false },
            { title: "e-up!", image: "e-up.png", selected: false },
            { title: "Polo", image: "polo.png", selected: false },
            { title: "Golf 8", image: "golf-8.png", selected: false },
            { title: "Golf Estate 8", image: "golf-estate-8.png", selected: false },
            // { title: "Golf Estate", image: "golf-estate.png", selected: false },
            // { title: "e-Golf", image: "e-golf.png", selected: false },
            { title: "ID.3", image: "id3.png", selected: false },
            { title: "ID.4", image: "id4.png", selected: false },
            { title: "T-Cross", image: "t-cross.png", selected: false },
            { title: "T-Roc", image: "t-roc.png", selected: false },
            { title: "New T-Roc Cabriolet", image: "new-troc-cabriolet.png", selected: false },
            { title: "New Tiguan", image: "new-tiguan.png", selected: false },
            { title: "Tiguan Allspace", image: "tiguan-allspace.png", selected: false },
            { title: "Touareg", image: "touareg.png", selected: false },
            { title: "Passat Saloon", image: "passat-saloon.png", selected: false },
            { title: "Passat Estate", image: "passat-estate.png", selected: false },
            { title: "New Arteon", image: "new-arteon.png", selected: false },
            { title: "Arteon Shooting Brake", image: "arteon-shooting-brake.png", selected: false },
            { title: "Arteon", image: "arteon.png", selected: false },
            { title: "Touran", image: "touran.png", selected: false },
            { title: "Sharan", image: "sharan.png", selected: false },
          ],
        },
        finance: {
          budgets: [
            { title: "£99 - £149", value: "£99 - £149", selected: false },
            { title: "£150 - £199", value: "£150 - £199", selected: false },
            { title: "£200 - £249", value: "£200 - £249", selected: false },
            { title: "£250 - £299", value: "£250 - £299", selected: false },
            { title: "£300 - £349", value: "£300 - £349", selected: false },
            { title: "£350 - £399", value: "£350 - £399", selected: false },
            { title: "£400 - £449", value: "£400 - £449", selected: false },
          ],
          mileages: [
            { title: "5,000", value: "5,000", selected: false },
            { title: "10,000", value: "10,000", selected: false },
            { title: "15,000", value: "15,000", selected: false },
            { title: "20,000", value: "20,000", selected: false },
            { title: "25,000", value: "25,000", selected: false },
            { title: "30,000", value: "30,000", selected: false },
          ],
          deposit: "",
        },
        details: {
          title: "",
          firstName: "",
          lastName: "",
          emailAddress: "",
          mobile: "",
          phone: "",
          finance: "",
          branchName: "",
          branchAddress1: "",
          branchAddress2: "",
          branchAddress3: "",
          branchPostcode: "",
          branchTradingName: "",
          branchTelephone: "",
          branchContactEmail: "",
          branchToEmail: "",
          branchFromEmail: "",
        },
        partExchange: {
          make: "",
          model: "",
          registration: "",
          mileage: "",
          transmission: "",
          fuel: "",
          colour: "",
          contractStartDate: "",
          contractEndDate: "",
          monthlyPayment: "",
          conditions: [
            { title: "Good", value: "Good", selected: false },
            { title: "Average", value: "Average", selected: false },
            { title: "Poor", value: "Poor", selected: false },
          ],
          currentMileage: "",
          comments: "",
        },
        summary: {
          contactMethods: [
            { title: "Email", value: "Email", selected: false },
            { title: "Sms", value: "Sms", selected: false },
            { title: "Telephone", value: "Telephone", selected: false },
          ],
          contactTimes: [
            { title: "Morning", value: "Morning", selected: false },
            { title: "Afternoon", value: "Afternoon", selected: false },
            { title: "Evening", value: "Evening", selected: false },
          ],
          contactDays: [
            { title: "Monday", value: "Monday", selected: false },
            { title: "Tuesday", value: "Tuesday", selected: false },
            { title: "Wednesday", value: "Wednesday", selected: false },
            { title: "Thursday", value: "Thursday", selected: false },
            { title: "Friday", value: "Friday", selected: false },
            { title: "Saturday", value: "Saturday", selected: false },
            { title: "Sunday", value: "Sunday", selected: false },
          ],
        },
        confirmation: {},
      };

    default:
      return state;
  }
};

export default DataReducer;
